module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-tabela"
  }, [(!_vm.disableCheckAll && _vm.checkItem.length > 0) ? _c('div', {
    staticClass: "ed-tabela__bulkbar"
  }, [_c('span', {
    staticClass: "ed-tabela__bulkbar-count"
  }, [_vm._v(_vm._s(_vm.checkItem.length) + " selecionado(s)")]), _vm._v(" "), _c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "ed-tabela__bulkbar-info"
  }, [_vm._v(_vm._s(_vm.selectedEligibleForXml.length) + " pode(m) gerar XML")]), _vm._v(" "), (_vm.onBulkGerarXml) ? [_c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action",
    attrs: {
      "disabled": !_vm.selectedEligibleForXml.length
    },
    on: {
      "click": _vm.handleBulkGerarXml
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-file-circle-plus"
  }), _vm._v(" Gerar XML\n      ")])] : _vm._e(), _vm._v(" "), (_vm.onEditAll) ? [_c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action",
    on: {
      "click": _vm.handleBulkEditAll
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Editar selecionados\n      ")])] : _vm._e(), _vm._v(" "), (_vm.onDelete) ? [_c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action ed-tabela__bulkbar-action--danger",
    on: {
      "click": _vm.handleBulkDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Excluir selecionados\n      ")])] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action",
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("Cancelar")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ed-tabela__scroll"
  }, [_c('table', {
    staticClass: "ed-tabela__table"
  }, [_c('thead', [_c('tr', [(!_vm.disableCheckAll) ? _c('th', {
    staticClass: "ed-tabela__th-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }, _vm.handleSelectAll]
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHead), function(col) {
    return _c('th', {
      key: col.key,
      class: {
        'is-sortable': col.sortable
      },
      style: ({
        width: col.width
      }),
      on: {
        "click": function($event) {
          col.sortable && _vm.toggleSort(col.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(col.label) + "\n            "), (col.sortable && _vm.sortKey == col.key && !_vm.sortDesc) ? _c('i', {
      staticClass: "fa fa-sort-asc"
    }) : _vm._e(), _vm._v(" "), (col.sortable && _vm.sortKey == col.key && _vm.sortDesc) ? _c('i', {
      staticClass: "fa fa-sort-desc"
    }) : _vm._e(), _vm._v(" "), (col.sortable && _vm.sortKey != col.key) ? _c('i', {
      staticClass: "fa fa-sort ed-tabela__sort-idle"
    }) : _vm._e(), _vm._v(" "), (col.info) ? _c('i', {
      staticClass: "fa fa-question-circle ed-tabela__th-info",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "mouseenter": function($event) {
          return _vm.showTooltip(col.info, $event)
        },
        "mouseleave": _vm.hideTooltip
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    staticClass: "ed-tabela__th-actions"
  }, [_vm._v(" ")])], 2)]), _vm._v(" "), (_vm.loadingTable) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ed-tabela__state",
    attrs: {
      "colspan": _vm.colspan
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Carregando...\n          ")])])]) : (!_vm.sortedData.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ed-tabela__state",
    attrs: {
      "colspan": _vm.colspan
    }
  }, [_vm._v(_vm._s(_vm.emptyMessage))])])]) : _c('tbody', _vm._l((_vm.sortedData), function(row) {
    return _c('tr', {
      key: row._data.id,
      class: {
        'is-deleted': row._data.deleted_at
      }
    }, [(!_vm.disableCheckAll) ? _c('td', {
      staticClass: "ed-tabela__th-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkItem),
        expression: "checkItem"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": row.options && row.options.disable_select,
        "title": row.options && row.options.disable_select ? 'Este registro não pode ser selecionado' : null
      },
      domProps: {
        "value": row._data.id,
        "checked": Array.isArray(_vm.checkItem) ? _vm._i(_vm.checkItem, row._data.id) > -1 : (_vm.checkItem)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row._data.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkItem = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkItem = $$c
          }
        }, _vm.handleSelectItem]
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHead), function(col) {
      return _c('td', {
        key: col.key
      }, [(col.show_empresa_link) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlEmpresa(row._data),
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })]), _vm._v(" "), (col.show_fdt && row._data.fdt && row._data.fdt.pcmso) ? _c('div', {
        staticClass: "ed-tabela__sub"
      }, [_vm._v("\n                " + _vm._s(row._data.fdt.pcmso) + " (" + _vm._s(row._data.fdt.descricao) + ")\n              ")]) : _vm._e()] : (col.show_funcionario_link) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlFuncionario(row._data),
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })]), _vm._v(" "), (col.show_funcao && row._data.funcao) ? _c('div', {
        staticClass: "ed-tabela__sub"
      }, [_vm._v("\n                " + _vm._s(row._data.funcao.nome) + "\n              ")]) : _vm._e()] : (col.show_consulta_link && row._data.id_con) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlConsulta(row._data),
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })])] : (col.show_lote_link) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlLote(row._data),
          "target": "_blank"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })])] : (col.key == 'tipo_status' && row._data.tipo_status) ? [_c('button', {
        staticClass: "ed-tabela__badge",
        class: {
          'ed-tabela__badge--conflito': _vm.hasConflito(row._data),
          'ed-tabela__badge--timeline': col.show_status_timeline
        },
        style: ({
          color: row._data.tipo_status.cor,
          background: _vm.hexToRgba(row._data.tipo_status.cor, 0.12),
        }),
        attrs: {
          "disabled": !_vm.hasConflito(row._data) && !col.show_status_timeline,
          "title": _vm.hasConflito(row._data) ? _vm.conflitoCount(row._data) + ' conflito(s) encontrado(s)' : null
        },
        on: {
          "click": function($event) {
            return _vm.handleStatusClick(col, row._data, $event)
          }
        }
      }, [(row._data.tipo_status.icon) ? _c('i', {
        class: [row._data.tipo_status.icon, {
          'ed-tabela__badge-pulse': _vm.hasConflito(row._data)
        }]
      }) : _vm._e(), _vm._v("\n                " + _vm._s(row._data.tipo_status.descricao) + "\n                "), (col.show_status_timeline) ? _c('i', {
        staticClass: "fa fa-chevron-down ed-tabela__badge-caret"
      }) : _vm._e()])] : (col.show_user) ? [_c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      }), _vm._v(" "), (row._data.usuario) ? _c('div', {
        staticClass: "ed-tabela__sub"
      }, [_vm._v(_vm._s(row._data.usuario.usuario))]) : _vm._e()] : (col.show_arquivo) ? [(row[col.key] && row[col.key].id) ? _c('Download', {
        attrs: {
          "arquivo": row[col.key]
        }
      }) : _c('span', [_vm._v("---")])] : (col.show_eventos && row[col.key]) ? [_c('button', {
        staticClass: "ed-tabela__eventos-btn",
        on: {
          "click": function($event) {
            return _vm.toggleEventos(row[col.key], $event)
          }
        }
      }, [_c('span', {
        staticClass: "ed-tabela__eventos-total"
      }, [_vm._v(_vm._s(row[col.key].total))]), _vm._v(" evento(s)\n                "), _c('span', {
        staticClass: "ed-tabela__eventos-count ed-tabela__eventos-count--success"
      }, [_vm._v("\n                  " + _vm._s(row[col.key].enviado || 0) + "\n                ")]), _vm._v(" "), _c('span', {
        staticClass: "ed-tabela__eventos-sep"
      }, [_vm._v("/")]), _vm._v(" "), _c('span', {
        staticClass: "ed-tabela__eventos-count ed-tabela__eventos-count--danger"
      }, [_vm._v("\n                  " + _vm._s(row[col.key].erro || 0) + "\n                ")])])] : (col.edit && _vm.editableRows) ? [(col.edit == 'text') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row._data[col.key]),
          expression: "row._data[col.key]"
        }],
        staticClass: "ed-tabela__input",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (row._data[col.key])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row._data, col.key, $event.target.value)
          }
        }
      }) : (col.edit == 'money') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row._data[col.key]),
          expression: "row._data[col.key]"
        }, {
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        staticClass: "ed-tabela__input",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (row._data[col.key])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row._data, col.key, $event.target.value)
          }
        }
      }) : (col.edit == 'number') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row._data[col.key]),
          expression: "row._data[col.key]"
        }],
        staticClass: "ed-tabela__input",
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (row._data[col.key])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row._data, col.key, $event.target.value)
          }
        }
      }) : _vm._e()] : [_c('span', {
        class: {
          'ed-tabela__value--bold': col.bold
        },
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })]], 2)
    }), _vm._v(" "), _c('td', {
      staticClass: "ed-tabela__actions"
    }, _vm._l((row.buttons), function(btn, i) {
      return _c('button', {
        key: i,
        staticClass: "ed-tabela__icon-btn",
        style: (_vm.btnStyle(btn)),
        attrs: {
          "aria-label": btn.title,
          "disabled": !!btn.disabled
        },
        on: {
          "click": function($event) {
            btn.click && btn.click(row._data)
          },
          "mouseenter": function($event) {
            return _vm.showTooltip(btn.title, $event)
          },
          "mouseleave": _vm.hideTooltip
        }
      }, [_c('i', {
        class: btn.icon
      })])
    }), 0)], 2)
  }), 0)])]), _vm._v(" "), (_vm.pagination && _vm.pagination.total) ? _c('div', {
    staticClass: "ed-tabela__footer"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ppage),
      expression: "ppage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "ed-tabela__pp",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.ppage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handlePerPage]
    }
  }, _vm._l((_vm.lstPages), function(p) {
    return _c('option', {
      key: p,
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p) + " por página")])
  }), 0), _vm._v(" "), _c('ed-paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "navigation": _vm.handleNavigate
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.popover.open) ? _c('div', {
    staticClass: "ed-tabela__conflito-overlay",
    on: {
      "click": _vm.closePopover
    }
  }) : _vm._e(), _vm._v(" "), (_vm.popover.open) ? _c('div', {
    staticClass: "ed-tabela__conflito-popover",
    style: (_vm.popover.pos),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.popover.type == 'conflito') ? _c('conflitos-detalhe', {
    attrs: {
      "item": _vm.popover.payload
    }
  }) : (_vm.popover.type == 'eventos') ? _c('div', {
    staticClass: "ed-tabela__eventos-detalhe"
  }, [_c('div', {
    staticClass: "ed-tabela__eventos-detalhe-row"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.total))])]), _vm._v(" "), _c('div', {
    staticClass: "ed-tabela__eventos-detalhe-row ed-tabela__eventos-detalhe-row--success"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" "), _c('span', [_vm._v("Com sucesso")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.enviado || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "ed-tabela__eventos-detalhe-row ed-tabela__eventos-detalhe-row--danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v("Com erro")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.erro || 0))])])]) : (_vm.popover.type == 'timeline') ? _c('div', {
    staticClass: "ed-tabela__timeline"
  }, _vm._l((_vm.timelinePassos(_vm.popover.payload)), function(step) {
    return _c('div', {
      key: step.id,
      staticClass: "ed-tabela__timeline-step",
      class: {
        'ed-tabela__timeline-step--done': step.ordem < _vm.timelineAtual(_vm.popover.payload).ordem,
        'ed-tabela__timeline-step--atual': step.ordem == _vm.timelineAtual(_vm.popover.payload).ordem,
        'ed-tabela__timeline-step--erro': step.erro && step.ordem == _vm.timelineAtual(_vm.popover.payload).ordem,
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.timelineStepIcon(step, _vm.popover.payload)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.descricao))])])
  }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tooltip.visible) ? _c('div', {
    staticClass: "ed-tabela__tooltip",
    class: {
      'ed-tabela__tooltip--below': _vm.tooltip.below
    },
    style: ({
      top: _vm.tooltip.top + 'px',
      left: _vm.tooltip.left + 'px'
    })
  }, [_vm._v("\n    " + _vm._s(_vm.tooltip.text) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e68636d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/includes/tabela.vue
// module id = 1467
// module chunks = 45